"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorClearHover = exports.colorClearNormal = void 0;
exports.colorClearNormal = '#ff4040';
exports.colorClearHover = '#d00000';
